import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { appConfig } from 'utils/config';

const Page = forwardRef(
  ({ children, title = '', description = '', ...other }, ref) => {
    const pageTitle = `Purwadhika | ${title || 'Digital Technology School'}`;

    const defaultDescription = 'Purwadhika Digital Technology School';

    return (
      <div ref={ref} {...other}>
        <Helmet>
          <title>{pageTitle}</title>
          <link rel="icon" href="/favicon.ico" />
          <meta property="og:title" content={pageTitle} />
          <meta
            name="description"
            content={description || defaultDescription}
          />
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
        </Helmet>

        {children}
      </div>
    );
  },
);

export default Page;
